import { urlRoute } from './url';

class PathLink {
  constructor(path, link) {
    this.path = urlRoute(path);
    this.link =
      link && typeof link === 'function'
        ? (p, q) => urlRoute(link(p, q))
        : () => urlRoute(link) || urlRoute(path);
  }
}

export default PathLink;